<template>
  <section>
    <!--工具条-->
    <Toolbar :buttonList="buttonList" @callFunction="callFunction">
      <template v-slot:before>
        <el-form-item>
          <el-select
            v-model="selMode"
            placeholder="类型"
            collapse-tags
            style="width: 150px !important"
          >
            <el-option label="全部类型" value="0"></el-option>
            <el-option label="商城" value="1"></el-option>
            <el-option label="外卖" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="selStatus"
            multiple
            placeholder="请选择状态"
            clearable
            collapse-tags
            style="width: 150px !important"
          >
            <el-option
              v-for="(item, key) in $t('Order.StatusList')"
              :key="key"
              :label="item"
              :value="parseInt(key)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="startDate"
            type="date"
            placeholder="开始时间"
            value-format="yyyy-MM-dd"
            style="width: 150px !important"
            :editable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="endDate"
            type="date"
            placeholder="结束时间"
            value-format="yyyy-MM-dd"
            style="width: 150px !important"
            :editable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-switch
            v-model="dateType"
            active-text="提交时间"
            inactive-text="配送时间"
          ></el-switch>
        </el-form-item>
      </template>
    </Toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      :height="getTableHeight(165)"
      row-key="Id"
      class="olist"
      stripe
      border
    >
      <el-table-column :label="$t('Order.OrderNo')" width="170">
        <template slot-scope="scope"
          >{{ scope.row.OrderNo }}（{{ scope.row.TakeNo }}）</template
        >
      </el-table-column>
      <el-table-column type="expand" width="40">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.Status == 402"
            type="danger"
            size="mini"
            style="margin-bottom: 5px"
            @click="openCancelOrder(scope.row)"
            :loading="openRefundOrderLoading"
            >确认退款</el-button
          >
          <el-row :gutter="20" class="remarkRow">
            <el-col :span="2" class="tit">{{ $t("Remark") }}：</el-col>
            <el-col :span="22">{{ scope.row.Remark }}</el-col>
          </el-row>
          <el-row
            :gutter="20"
            class="remarkRow"
            v-if="scope.row.KoipyDeduct > 0"
          >
            <el-col :span="2" class="tit">余额支付：</el-col>
            <el-col :span="22" class="text_powder"
              >${{ scope.row.KoipyDeduct }}</el-col
            >
          </el-row>
          <el-row :gutter="20" class="remarkRow" v-if="scope.row.Freight > 0">
            <el-col :span="2" class="tit">运费：</el-col>
            <el-col :span="22" class="text_red"
              >${{ scope.row.Freight }}</el-col
            >
          </el-row>
          <el-row :gutter="20" class="remarkRow" v-if="scope.row.Gst > 0">
            <el-col :span="2" class="tit">Gst：</el-col>
            <el-col :span="22" class="text_red"
              >${{ scope.row.Gst }}</el-col
            >
          </el-row>
          <el-row :gutter="20" class="remarkRow" v-if="scope.row.Derate > 0">
            <el-col :span="2" class="tit">{{ scope.row.DerateName }}：</el-col>
            <el-col :span="22" class="text_red"
              >-${{ scope.row.Derate }}</el-col
            >
          </el-row>
          <el-row
            :gutter="20"
            class="remarkRow"
            v-if="scope.row.FirstDerate > 0"
          >
            <el-col :span="2" class="tit"
              >{{ scope.row.FirstDerateName }}：</el-col
            >
            <el-col :span="22" class="text_red"
              >-${{ scope.row.FirstDerate }}</el-col
            >
          </el-row>
          <el-row :gutter="20" class="remarkRow" v-if="scope.row.Donate > 0">
            <el-col :span="2" class="tit">返利：</el-col>
            <el-col :span="22" class="text_red">${{ scope.row.Donate }}</el-col>
          </el-row>
          <el-row :gutter="20" class="remarkRow">
            <el-col :span="2" class="tit">Fomo Order Id：</el-col>
            <el-col :span="22">{{ scope.row.FomoOrderId }}</el-col>
          </el-row>
          <el-row :gutter="20" class="remarkRow">
            <el-col :span="2" class="tit">Fomo Wallet Id：</el-col>
            <el-col :span="22">{{ scope.row.FomoWalletId }}</el-col>
          </el-row>
          <el-table
            border
            :data="scope.row.OrderItem"
            v-loading="itemListLoading"
            show-summary
            style="width: 1000px"
            size="mini"
          >
            <el-table-column :label="$t('Name')">
              <template slot-scope="scope">{{
                field(scope.row.Name)
              }}</template>
            </el-table-column>
            <el-table-column :label="$t('Spec')">
              <template slot-scope="scope">
                <div
                  class="specItem"
                  v-for="item in scope.row.ProductSpec"
                  :key="item.Id"
                >
                  {{ field(item.Name) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="Number"
              label="数量"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="Price"
              label="单价"
              width="100"
            ></el-table-column>
            <el-table-column prop="Total" :label="$t('Total')" width="100">
              <template slot-scope="scope">
                <span class="text_red">$ {{ scope.row.Total }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('operation')" width="168">
              <template slot="header">
                <el-button
                  type="success"
                  size="mini"
                  @click="addItem(scope.row.Id, scope.row.ShopConfig.Eid)"
                  >{{ $t("add") }}</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="updateTotal(scope.row.Id)"
                  >{{ $t("Order.UpdateTotal") }}</el-button
                >
              </template>
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="editItem(scope.row)"
                  v-loading="openitemLoading"
                  icon="el-icon-edit"
                ></el-button>
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="deleteItem(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Shop.Name')"
        width="130"
        show-overflow-tooltip
      >
        <template slot-scope="scope">{{
          field(scope.row.ShopConfig.Name)
        }}</template>
      </el-table-column>
      <el-table-column :label="$t('Enabled')" width="125">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="EditStatus(scope.row)"
            :class="'text_white state' + scope.row.Status"
            disable-transitions
            >{{ $t("Order.selStatusList")[scope.row.Status] }}</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="订单合计" width="90">
        <template slot-scope="scope">
          <span class="text_red"
            >${{
              (scope.row.Total + scope.row.Freight + scope.row.Gst).toFixed(2)
            }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="实际支付" width="90">
        <template slot-scope="scope">
          <span class="text_red"
            >$
            {{
              (
                scope.row.Total -
                scope.row.KoipyDeduct +
                scope.row.Freight +
                scope.row.Gst
              ).toFixed(2)
            }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="配送状态" width="110">
        <template slot-scope="scope">
          <el-tag
            size="mini"
            v-if="scope.row.Express != null"
            :class="'psstate' + scope.row.Express.Status"
            effect="plain"
            >{{ $t("Express.StatusList")[scope.row.Express.Status] }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="配送时间" width="180">
        <template slot-scope="scope"
          >{{ formatDate(scope.row.ShippingDate) }}
          {{ scope.row.ShippingTime.StartTime }}~{{
            scope.row.ShippingTime.EndTime
          }}</template
        >
      </el-table-column>
      <el-table-column
        label="内部备注"
        prop="InternalRemark"
        width="150"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="PayType" :label="$t('PayMode')" width="90">
        <template slot-scope="scope">{{
          $t("Order.PayType." + scope.row.PayType)
        }}</template>
      </el-table-column>
      <el-table-column
        label="收货人"
        prop="Consignee"
        width="130"
      ></el-table-column>
      <el-table-column
        label="联系电话"
        prop="Phone"
        width="100"
      ></el-table-column>
      <el-table-column
        label="收货地址"
        prop="Address"
        width="250"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="邮编" prop="ZipCode" width="70"></el-table-column>
      <el-table-column
        label="备注"
        prop="Remark"
        width="300"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="下单人" width="60">
        <template slot-scope="scope">
          <el-button
            size="small"
            @click="openUserInfo(scope.row.UserId)"
            type="info"
            icon="el-icon-user-solid"
            circle
            :loading="openUserInfoLoading"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Order.SubmitTime')"
        prop="DateTime"
        width="100"
        fixed="right"
      >
        <template slot-scope="scope">{{
          formatDateTime(scope.row.DateTime)
        }}</template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total,prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      :title="$t('edit')"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      size="small"
    >
      <el-form
        :model="editForm"
        label-width="150px"
        ref="editForm"
        size="small"
      >
        <el-form-item label="取餐号">
          <el-input v-model.number="editForm.TakeNo"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Order.ShippingDate')" prop="ShippingDate">
          <el-date-picker
            v-model="editForm.ShippingDate"
            type="date"
            placeholder="选择日期"
            :editable="false"
            @change="shippingDateChange"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="配送时间"
          prop="ShippingTime_Id"
          :rules="{ required: true, message: $t('pleaseEnter') + '配送时间' }"
        >
          <el-select
            v-model="editForm.ShippingTime_Id"
            placeholder="Select Time"
          >
            <el-option
              v-for="item in shippingTimeList"
              :key="item.Id"
              :label="item.StartTime + '~' + item.EndTime"
              :value="item.Id"
            >
              <span>{{ item.StartTime }}~{{ item.EndTime }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Remark')">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2 }"
            v-model="editForm.Remark"
          ></el-input>
        </el-form-item>
        <el-form-item label="内部备注">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2 }"
            v-model="editForm.InternalRemark"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="收货人"
          prop="Consignee"
          :rules="{ required: true, message: $t('pleaseEnter') + '收货人' }"
        >
          <el-input v-model.number="editForm.Consignee" type="text"></el-input>
        </el-form-item>
        <el-form-item
          label="联系电话"
          prop="Phone"
          :rules="{ required: true, message: $t('pleaseEnter') + '联系电话' }"
        >
          <el-input
            v-model="editForm.Phone"
            type="text"
            maxlength="8"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Order.Freight')"
          prop="Freight"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('Order.Freight'),
          }"
        >
          <el-input-number
            v-model.number="editForm.Freight"
            :precision="2"
            :step="0.1"
            :max="9999"
            style="width: 195px"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          :label="$t('Total')"
          prop="Total"
          :rules="{ required: true, message: $t('pleaseEnter') + $t('Total') }"
        >
          <el-input-number
            v-model.number="editForm.Total"
            :precision="2"
            :step="0.1"
            :max="9999"
            style="width: 195px"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>

    <!--添加项目界面-->
    <el-dialog
      :title="$t('addItem')"
      :visible.sync="addItemFormVisible"
      v-model="addItemFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addItemForm" label-width="150px" ref="addItemForm">
        <el-form-item
          label="产品"
          prop="Product_Id"
          :rules="{ required: true, message: $t('pleaseChoose') + '产品' }"
        >
          <SearchProduct
            v-model="addItemForm.Product_Id"
            :text="addItemForm.Name"
            @text="
              (text) => {
                addItemForm.Name = text;
              }
            "
            :SpecTypeList="addItemForm.ProductSpecType"
            @SpecTypeList="
              (SpecTypeList) => {
                addItemForm.ProductSpecType = SpecTypeList;
              }
            "
            :Product="addItemForm.Product"
            @Product="
              (Product) => {
                addItemForm.Product = Product;
              }
            "
            :shopId="addItemForm.ShopId"
            @change="refreshPrice"
          ></SearchProduct>
        </el-form-item>
        <el-form-item label="默认单价" v-if="addItemForm.Product.Price"
          >$ {{ addItemForm.Product.Price }}</el-form-item
        >
        <el-form-item
          label="数量"
          prop="Number"
          :rules="{ required: true, message: $t('pleaseEnter') + '数量' }"
        >
          <el-input
            v-model.number="addItemForm.Number"
            type="text"
            style="width: 150px"
            maxlength="5"
            @change="refreshPrice"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-for="item in addItemForm.ProductSpecType"
          :key="item.Id"
          :label="field(item.Name)"
        >
          <el-tag
            :type="items.sel ? 'danger' : 'info'"
            v-for="items in item.ProductSpecList"
            :key="items.Id"
            :class="items.sel ? 'spectag' : 'spechdtag'"
            @click="specTagClick(items)"
            >{{ field(items.Name) }} (${{ items.Price }})</el-tag
          >
        </el-form-item>
        <el-form-item
          label="单价"
          prop="Price"
          :rules="{ required: true, message: $t('pleaseEnter') + '单价' }"
        >
          <el-input-number
            v-model.number="addItemForm.Price"
            :precision="2"
            :step="0.1"
            :max="9999"
            style="width: 195px"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          :label="$t('Total')"
          prop="Total"
          :rules="{ required: true, message: $t('pleaseEnter') + $t('Total') }"
        >
          <el-input-number
            v-model.number="addItemForm.Total"
            :precision="2"
            :step="0.1"
            :max="9999"
            style="width: 195px"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addItemFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="addItemSubmit"
          :loading="addItemLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog
      :title="$t('editItem')"
      :visible.sync="editItemFormVisible"
      v-model="editItemFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editItemForm" label-width="150px" ref="editItemForm">
        <el-form-item :label="$t('Name')">{{
          field(editItemForm.Name)
        }}</el-form-item>
        <el-form-item label="默认单价"
          >$ {{ editItemForm.Product.Price }}</el-form-item
        >
        <el-form-item
          label="数量"
          prop="Number"
          :rules="{ required: true, message: $t('pleaseEnter') + '数量' }"
        >
          <el-input
            v-model.number="editItemForm.Number"
            type="text"
            style="width: 150px"
            maxlength="5"
            @change="refreshUpPrice"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-for="item in editItemForm.ProductSpecType"
          :key="item.Id"
          :label="field(item.Name)"
        >
          <el-tag
            :type="items.sel ? 'danger' : 'info'"
            v-for="items in item.ProductSpecList"
            :key="items.Id"
            :class="items.sel ? 'spectag' : 'spechdtag'"
            @click="specUpTagClick(items)"
            >{{ field(items.Name) }} (${{ items.Price }})</el-tag
          >
        </el-form-item>
        <el-form-item
          label="单价"
          prop="Price"
          :rules="{ required: true, message: $t('pleaseEnter') + '单价' }"
        >
          <el-input-number
            v-model.number="editItemForm.Price"
            :precision="2"
            :step="0.1"
            :max="9999"
            style="width: 195px"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          :label="$t('Total')"
          prop="Total"
          :rules="{ required: true, message: $t('pleaseEnter') + $t('Total') }"
        >
          <el-input-number
            v-model.number="editItemForm.Total"
            :precision="2"
            :step="0.1"
            :max="9999"
            style="width: 195px"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editItemFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="editItemSubmit"
          :loading="editItemLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>

    <!--单独修改状态-->
    <el-dialog
      :title="$t('Order.EditStatus')"
      :visible.sync="editStatusVisible"
      v-model="editStatusVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editStatusForm" label-width="150px" ref="editStatusForm">
        <el-form-item :label="$t('Order.OrderNo')">{{
          editStatusForm.OrderNo
        }}</el-form-item>
        <el-form-item
          label="订单状态"
          prop="Status"
          :rules="{ required: true, message: $t('pleaseEnter') + '订单状态' }"
        >
          <el-select
            v-model="editStatusForm.Status"
            placeholder="Select Status"
          >
            <el-option
              v-for="(value, key) in $t('Order.StatusList')"
              :key="key"
              :label="value"
              :value="parseInt(key)"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editStatusVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="editStatusSubmit"
          :loading="editStatusLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>

    <!--导出选择-->
    <el-dialog
      title="生成选项"
      :visible.sync="deriveFormVisible"
      v-model="deriveFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="deriveForm" label-width="80px" ref="deriveForm">
        <el-form-item
          label="订单状态"
          prop="Status"
          :rules="{ required: true, message: $t('pleaseChoose') + '订单状态' }"
        >
          <el-select
            v-model.number="deriveForm.Status"
            placeholder="Select Status"
          >
            <el-option
              v-for="(value, key) in $t('Order.StatusList')"
              :key="key"
              :label="value"
              :value="parseInt(key)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="生成日期"
          prop="DateTime"
          :rules="{
            required: true,
            message: $t('pleaseChoose') + $t('DateTime'),
          }"
        >
          <el-date-picker
            v-model="deriveForm.DateTime"
            type="date"
            placeholder="Select DateTime"
            :editable="false"
            @change="upDateTimeChange"
            clearable
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="deriveFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="deriveSubmit"
          :loading="deriveLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--用户详细-->
    <el-dialog
      title="用户详细"
      :visible.sync="UserInfoVisible"
      v-model="UserInfoVisible"
      :close-on-click-modal="false"
      size="small"
      width="30%"
    >
      <el-form :model="userInfo" size="small">
        <div class="headview">
          <img v-bind:src="userInfo.headurl" class="headimg" />
          <div class="data">
            <div>{{ userInfo.name }}</div>
            <div>手机号码 ：{{ userInfo.phone }}</div>
            <div>
              余额 ：<span class="text_red">{{ userInfo.credit }}</span>
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="UserInfoVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <!--退款-->
    <el-dialog
      title="退款"
      :visible.sync="refundOrderVisible"
      v-model="refundOrderVisible"
      :close-on-click-modal="false"
      size="small"
      width="40%"
    >
      <el-form
        :model="refundOrderForm"
        label-width="150px"
        size="small"
        ref="refundOrderForm"
      >
        <div class="headview">
          <img v-bind:src="userInfo.headurl" class="headimg" />
          <div class="data">
            <div>{{ userInfo.name }}</div>
            <div>手机号码 ：{{ userInfo.phone }}</div>
            <div>
              余额 ：<span class="text_red">{{ userInfo.credit }}</span>
            </div>
          </div>
        </div>
        <el-form-item label="订单合计">
          {{ refundOrderForm.Total }}
        </el-form-item>
        <el-form-item label="返利金额">
          {{ refundOrderForm.Gst }}
        </el-form-item>
        <el-form-item label="运费金额">
          {{ refundOrderForm.Freight }}
        </el-form-item>
        <el-form-item label="减免金额">
          {{ refundOrderForm.Derate }}
        </el-form-item>
        <el-form-item label="返利金额">
          {{ refundOrderForm.Donate }}
        </el-form-item>
        <el-form-item
          label="退款金额"
          prop="Amount"
          :rules="{ required: true, message: $t('pleaseEnter') + '退款金额' }"
        >
          <el-input-number
            v-model.number="refundOrderForm.Amount"
            :precision="2"
            :step="0.1"
            :max="9999"
            style="width: 195px"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="管理费返还"
          prop="adminFee"
          :rules="{ required: true, message: $t('pleaseEnter') + '管理费返还' }"
        >
          <el-input-number
            v-model.number="refundOrderForm.adminFee"
            :precision="2"
            :step="0.1"
            :max="9999"
            style="width: 195px"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="内部备注">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2 }"
            v-model="refundOrderForm.InternalRemark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="refundOrderVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="refundOrderSubmit"
          :loading="openRefundOrderLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import SearchProduct from "./SearchProduct";
import util from "util/date";
import {
  base,
  getAllOrderListPage,
  editOrder,
  getOrderItemProduct,
  getOrderItem,
  addOrderItem,
  editOrderItem,
  removeOrderItem,
  getShippingTime,
  updateOrderTotal,
  editStatus,
  getAllOrderExportShops,
  getAllOrderExportTeam,
  getUserInfoById,
  refundOrder,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";

export default {
  components: {
    SearchProduct,
  },
  data() {
    return {
      filters: {
        Name: "",
      },
      startDate: "",
      endDate: "",
      total: 0,
      buttonList: [],
      list: [],
      page: 1,
      listLoading: false,
      dateType: false,
      statusLoading: false,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: {},
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: {},
      editItemFormVisible: false, //编辑界面是否显示
      editItemLoading: false,
      //编辑界面数据
      editItemForm: { Product: {} },
      addItemFormVisible: false, //编辑界面是否显示
      addItemLoading: false,
      //编辑界面数据
      addItemForm: { Product: {} },
      selMode: "0",
      selStatus: [],
      shippingTimeList: [],
      openitemLoading: false,
      tagsx: 0,
      itemListLoading: false,
      editStatusLoading: false,
      editStatusVisible: false,
      editStatusForm: {},
      editAllStatusVisible: false,
      editAllStatusLoading: false,
      editAllStatusForm: {},
      baseImgPathUrl: base + "/FileUpload/OrderImage/a0/",
      orderSrcList: [],
      deriveFormVisible: false,
      deriveLoading: false,
      deriveForm: {
        Type: 1,
        Status: null,
        DateTime: "",
      },
      openUserInfoLoading: false,
      UserInfoVisible: false,
      userInfo: {},
      openRefundOrderLoading: false,
      refundOrderVisible: false,
      refundOrderForm: {},
    };
  },
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd");
    },
    formatDateTime: function (val) {
      return util.formatDate.format(new Date(val), "MM-dd hh:mm");
    },
    upDateTimeChange(val) {
      this.deriveForm.DateTime = this.formatDate(val);
    },
    shippingDateChange(val) {
      this.editForm.ShippingDate = this.formatDate(val);
    },
    openCancelOrder(order) {
      let para = {
        id: order.UserId,
      };
      this.openRefundOrderLoading = true;
      console.log(order);
      getUserInfoById(para).then((res) => {
        this.refundOrderForm = {
          OrderId: order.Id,
          UserId: order.UserId,
          Donate: order.Donate,
          Derate: order.Derate,
          Total: order.Total,
          Freight: order.Freight,
          Gst: order.Gst,
          Amount: order.Total + order.Freight - order.Donate + order.Gst,
          adminFee: order.Total * order.ShopConfig.Commission,
          InternalRemark: "",
          shopId: order.Shop_Id,
        };
        this.userInfo = res.data.response;
        this.refundOrderVisible = true;
        this.openRefundOrderLoading = false;
      });
    },
    refundOrderSubmit() {
      this.$refs.refundOrderForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.openRefundOrderLoading = true;
              let para = Object.assign({}, this.refundOrderForm);
              refundOrder(para).then((res) => {
                this.openRefundOrderLoading = false;
                if (util.isEmt.format(res)) {
                  return;
                }
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.refundOrderVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    openUserInfo(uid) {
      let para = {
        id: uid,
      };
      this.openUserInfoLoading = true;
      getUserInfoById(para).then((res) => {
        this.userInfo = res.data.response;
        this.UserInfoVisible = true;
        this.openUserInfoLoading = false;
      });
    },
    exportShops() {
      if (this.startDate == "") {
        this.$message({
          message: "请选择开始时间",
          type: "error",
        });
        return;
      }
      if (this.endDate == "") {
        this.$message({
          message: "请选择结束时间",
          type: "error",
        });
        return;
      }
      this.deriveForm.Type = 1;
      this.deriveFormVisible = true;
    },
    exportTeam() {
      if (this.startDate == "") {
        this.$message({
          message: "请选择开始时间",
          type: "error",
        });
        return;
      }
      if (this.endDate == "") {
        this.$message({
          message: "请选择结束时间",
          type: "error",
        });
        return;
      }
      this.deriveForm.Type = 2;
      this.deriveFormVisible = true;
    },
    deriveSubmit() {
      this.$refs.deriveForm.validate((valid) => {
        if (valid) {
          this.$confirm("确定生成吗？", this.$t("prompt"), {})
            .then(() => {
              this.deriveLoading = true;
              let para = {
                status: this.deriveForm.Status,
                deriveDate: this.deriveForm.DateTime,
                startDate: this.startDate,
                endDate: this.endDate,
              };
              switch (this.deriveForm.Type) {
                case 1:
                  getAllOrderExportShops(para).then((res) => {
                    var filename = res.headers; //下载后文件名
                    filename = filename["content-disposition"];
                    filename = filename.split(";")[1].split("filename=")[1];
                    const link = document.createElement("a");
                    const blob = new Blob([res.data], {
                      type: "application/zip",
                    });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", decodeURIComponent(filename));
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.deriveLoading = false;
                    this.deriveFormVisible = false;
                  });
                  break;
                case 2:
                  getAllOrderExportTeam(para).then((res) => {
                    var filename = res.headers; //下载后文件名
                    filename = filename["content-disposition"];
                    filename = filename.split(";")[1].split("filename=")[1];
                    const link = document.createElement("a");
                    const blob = new Blob([res.data], {
                      type: "application/vnd.ms-excel;charset=utf-8",
                    });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", decodeURIComponent(filename));
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.deriveLoading = false;
                    this.deriveFormVisible = false;
                  });
                  break;
              }
            })
            .catch(() => {});
        }
      });
    },
    EditStatus(row) {
      this.editStatusForm = Object.assign({}, this.clone(row));
      this.editStatusVisible = true;
    },
    editStatusSubmit() {
      this.$refs.editStatusForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.editStatusLoading = true;
              let para = Object.assign({}, this.editStatusForm);
              editStatus(para).then((res) => {
                this.editStatusLoading = false;
                if (util.isEmt.format(res)) {
                  return;
                }
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.editStatusVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    specTagClick(spec) {
      this.addItemForm.ProductSpecType.forEach(function (item, index, array) {
        if (item.Id == spec.Type_Id) {
          item.ProductSpecList.forEach(function (items, indexs, arrays) {
            if (items.Id == spec.Id) {
              items.sel = true;
            } else {
              items.sel = false;
            }
          });
        }
      });
      this.refreshPrice();
    },
    refreshPrice() {
      let _this = this;
      var selSepcList = [];
      _this.addItemForm.Price = _this.addItemForm.Product.Price;
      _this.addItemForm.ProductSpecType.forEach((item, index, arr) => {
        item.ProductSpecList.forEach((items, indexs, arrs) => {
          if (items.sel) {
            selSepcList.push(items);
            _this.addItemForm.Price += items.Price;
          }
        });
      });
      _this.addItemForm.ProductSpec = selSepcList;
      _this.addItemForm.Total =
        _this.addItemForm.Price * _this.addItemForm.Number;
      _this.$forceUpdate();
    },
    specUpTagClick(spec) {
      this.editItemForm.ProductSpecType.forEach(function (item, index, array) {
        if (item.Id == spec.Type_Id) {
          item.ProductSpecList.forEach(function (items, indexs, arrays) {
            if (items.Id == spec.Id) {
              items.sel = true;
            } else {
              items.sel = false;
            }
          });
        }
      });
      this.refreshUpPrice();
    },
    refreshUpPrice() {
      let _this = this;
      var selSepcList = [];
      _this.editItemForm.Price = _this.editItemForm.Product.Price;
      _this.editItemForm.ProductSpecType.forEach((item, index, arr) => {
        item.ProductSpecList.forEach((items, indexs, arrs) => {
          if (items.sel) {
            selSepcList.push(items);
            _this.editItemForm.Price += items.Price;
          }
        });
      });
      _this.editItemForm.ProductSpec = selSepcList;
      _this.editItemForm.Total =
        _this.editItemForm.Price * _this.editItemForm.Number;
      _this.$forceUpdate();
    },
    specIsSel(id, list) {
      var issel = false;
      if (list == null) {
        return issel;
      }
      list.forEach(function (item, index, array) {
        if (item.Id == id) {
          issel = true;
          return;
        }
      });
      return issel;
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        Name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    searchList() {
      this.page = 1;
      this.getList();
    },
    //获取列表
    getList() {
      let para = {
        key: this.filters.Name,
        mode: parseInt(this.selMode),
        status: this.selStatus,
        startTime: this.startDate,
        endTime: this.endDate,
        dateType: this.dateType,
        page: this.page,
      };
      this.listLoading = true;
      getAllOrderListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
    updateTotal(oid) {
      this.$confirm("您确定更新订单合计吗？", this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          let para = {
            id: oid,
          };
          updateOrderTotal(para).then((res) => {
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.list.forEach((item, index, arr) => {
                if (item.Id == oid) {
                  item.Total = res.data.response;
                }
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    //删除项目
    deleteItem(row) {
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          let para = { id: row.Id };
          removeOrderItem(para).then((res) => {
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.loadOrderItem(row.Order_Id);
          });
        })
        .catch(() => {});
    },
    addItem(oid, shopId) {
      this.addItemFormVisible = true;
      this.addItemForm = {
        Name: {},
        Order_Id: oid,
        Number: 1,
        Price: 0,
        Total: 0,
        ProductSpec: [],
        ProductSpecType: [],
        Product: {},
        ShopId: shopId,
      };
    },
    addItemSubmit() {
      let _this = this;
      if (
        this.addItemForm.ProductSpecType.length > 0 &&
        this.addItemForm.ProductSpec.length <
          this.addItemForm.ProductSpecType.length
      ) {
        this.$message({
          message: "请选择规格",
          type: "error",
        });
        return;
      }
      this.$refs.addItemForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addItemLoading = true;
              let para = Object.assign({}, this.addItemForm);
              addOrderItem(para).then((res) => {
                this.addItemLoading = false;
                if (util.isEmt.format(res)) {
                  return;
                }
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.addItemFormVisible = false;
                  this.loadOrderItem(this.addItemForm.Order_Id);
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    editItem(row) {
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      let para = { pid: row.Product_Id };
      this.openitemLoading = true;
      let _this = this;
      getOrderItemProduct(para).then((res) => {
        this.editItemFormVisible = true;
        this.editItemForm = Object.assign({}, this.clone(row));
        this.editItemForm.Product = res.data.response.product;
        this.editItemForm.ProductSpecType = res.data.response.productSpecType;
        if (this.editItemForm.ProductSpecType != null) {
          this.editItemForm.ProductSpecType.forEach(function (
            item,
            index,
            array
          ) {
            item.ProductSpecList.forEach(function (items, indexs, arrays) {
              items.sel = _this.specIsSel(
                items.Id,
                _this.editItemForm.ProductSpec
              );
            });
          });
        }
        this.openitemLoading = false;
      });
    },
    editItemSubmit() {
      if (
        this.editItemForm.ProductSpecType.length > 0 &&
        this.editItemForm.ProductSpec.length <
          this.editItemForm.ProductSpecType.length
      ) {
        this.$message({
          message: "请选择规格",
          type: "error",
        });
      }
      this.$refs.editItemForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.editItemLoading = true;
              let para = Object.assign({}, this.editItemForm);
              editOrderItem(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editItemLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editItemLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs.editItemForm.resetFields();
                  this.editItemFormVisible = false;
                  this.loadOrderItem(this.editItemForm.Order_Id);
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    loadOrderItem(oid) {
      let para = {
        oid: oid,
      };
      this.itemListLoading = true;
      getOrderItem(para).then((res) => {
        this.list.forEach(function (item, index, array) {
          if (item.Id == oid) {
            item.OrderItem = res.data.response;
          }
        });
        this.itemListLoading = false;
      });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      let para = { shopId: row.ShopConfig.Eid, isEnabled: true };
      getShippingTime(para).then((res) => {
        this.shippingTimeList = res.data.response;
        this.editFormVisible = true;
        this.editForm = Object.assign({}, this.clone(row));
      });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.editLoading = true;
              let para = Object.assign({}, this.editForm);
              editOrder(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.$refs.listTable.setCurrentRow();
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
  },
  mounted() {
    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style>
.remarkRow {
  line-height: 25px;
}
.remarkRow .tit {
  font-weight: bold;
}
.specItem {
  display: inline-block;
  background-color: #f1f2f4;
  border-radius: 3px;
  padding: 2px 10px;
  margin: 0 3px;
}
.olist .el-table__expanded-cell {
  padding-left: 180px !important;
}
.spectag {
  margin-right: 5px;
  cursor: default;
}
.spechdtag {
  margin-right: 5px;
  cursor: pointer;
}
.imgblock {
  padding: 30px 0;
  text-align: center;
  border-right: 1px solid #eff2f6;
  display: inline-block;
  width: 25%;
  box-sizing: border-box;
  vertical-align: top;
}
.headview {
  display: flex;
  align-items: center;
}
.headview img {
  margin-right: 20px;
}
.headview .data {
  height: 80px;
}
.headview .data div {
  line-height: 25px;
}
.headimg {
  width: 80px;
  height: 80px;
  border: 3px solid #f7a600;
  border-radius: 50%;
}

.state101 {
  background-color: mediumblue !important;
}
.state102 {
  background-color: rgb(255, 115, 0) !important;
}
.state201 {
  background-color: orange !important;
}

.state202 {
  background-color: lightcoral !important;
}

.state203 {
  background-color: lightcoral !important;
}

.state204 {
  background-color: lightcoral !important;
}

.state300 {
  background-color: limegreen !important;
}

.state401 {
  background-color: darkgray !important;
}

.state402 {
  background-color: tomato !important;
}

.state403 {
  background-color: darkgray !important;
}
.psstate1 {
  color: tomato !important;
  border-color: tomato !important;
}
.psstate2,
.psstate4,
.psstate6 {
  color: limegreen !important;
  border-color: limegreen !important;
}
.psstate3,
.psstate5,
.psstate7 {
  color: darkgray !important;
  border-color: darkgray !important;
}
</style>
